import { FC, Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { useStoreSelector } from "../../store/store";
import { blockchain } from "../../settings";
import { useTabIndex } from "../../hooks/useTabIndex";

import StartUpPage from "../pages/StartUpPage/StartUpPage";
// import Spinner from "../UI/spinner/spinner";

import './App.scss';

const MainPage = lazy(() => import("../pages/MainPage/MainPage"));
const SettingsPage = lazy(() => import("../pages/SettingsPage/SettingsPage"));
const ChromiaRegisterPage = lazy(() => import("../pages/ChromiaRegisterPage/ChromiaRegisterPage"));
const AssetsPage = lazy(() => import("../pages/AssetsPage/AssetsPage"));
const VaultsPage = lazy(() => import("../pages/VaultsPage/VaultsPage"));
const MainUpdater = lazy(() => import("../utilComponents/MainUpdater/MainUpdater"));
const Header = lazy(() => import("../Header/Header"));
const Footer = lazy(() => import("../Footer/Footer"));
const MobileMenu = lazy(() => import("../modals/MobileMenu/MobileMenu"));


const App: FC = () => {

	const {isInited} = useStoreSelector(store => store.app);
	const {isChrRegistered} = useStoreSelector(store => store.chromia);
	
	const isMobileMenuOpened = useTabIndex({position: 'last', modalName: 'mobileMenu'});


	return (
		<div className="App">
			<Suspense
				// fallback={<Spinner/>}
				fallback={<></>}
			>
				{!isInited?
					<StartUpPage/>
				:
					(blockchain === 'chromia' && !isChrRegistered)?
						<ChromiaRegisterPage/>
					:
						<>
							<Header/>
							<div className="App-content">
								<Switch>
									<Route exact path='/' component={MainPage}/>
									<Route exact path='/settings' component={SettingsPage}/>
									<Route exact path='/assets' component={AssetsPage}/>
									<Route exact path='/vaults' component={VaultsPage}/>
									<Redirect to='/'/>
								</Switch>
								{isMobileMenuOpened && <MobileMenu/>}
							</div>
							<Footer/>
							<MainUpdater/>
						</>
				}
			</Suspense>
		</div>
	)
}

export default App;